<template>
  <swipe class="my-swipe">
    <swipe-item :key="index" v-for="(item, index) in items">
      <div class="slide-container">
        <div class="box-img-slide">
          <img :src="item.image" class="img-responsive" />
        </div>
        <p class="slide-title">{{$t(item.title)}}</p>
        <p class="slide-sub-title">{{$t(item.desc)}}</p>
      </div>
    </swipe-item>
  </swipe>
</template>

<script>
import { Swipe, SwipeItem } from 'vue-swipe';
import Vue from 'vue';

require('vue-swipe/dist/vue-swipe.css');

Vue.component('swipe', Swipe);
Vue.component('swipe-item', SwipeItem);
export default {
  name: 'Slide',
  props: {
    items: Array,
  }
};
</script>

<style scoped="">
  .my-swipe {
    text-align: center;
    height: 300px;
    margin:auto;
    margin-top: 25%;
  }
  .slide-container {
    padding: 40px 30px;
    margin:auto;
  }
  .img-responsive {
    max-width: 200px;
    width: auto;
  }
  .slide-title {
    border-bottom: 1px solid gray;
    line-height: 40px;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .slide-sub-title {
    font-size: 16px;
    margin-top: 0;
    padding-top: 0;
  }
  .box-img-slide {
    height: 100px;
  }
</style>
<style>
  .mint-swipe-indicator {
    opacity: 1 !important;
    background: gray !important;
  }
  .mint-swipe-indicator.is-active {
    background: #2187c6 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Slide.vue